import { FC } from "react";
import { Container, Row, Col } from "react-bootstrap";
import styles from "./HeroSection.module.css";

interface HeroSectionProps {
  title: string;
  subtitle: string;
  imageSrc?: string;
  imageAlt?: string;
}

const HeroSection: FC<HeroSectionProps> = ({
  title,
  subtitle,
  imageSrc,
  imageAlt = "Hero image",
}) => {
  return (
    <section className={styles.hero}>
      <Container>
        <Row className="align-items-center">
          <Col lg={6} className={styles.textContent}>
            <h1 className={styles.title}>{title}</h1>
            <p className={styles.subtitle}>{subtitle}</p>
          </Col>
          <Col lg={6} className={styles.imageContent}>
            {imageSrc ? (
              <img
                src={imageSrc}
                alt={imageAlt}
                className={styles.heroImage}
              />
            ) : (
              <div className={styles.imagePlaceholder}>
                <span>Image placeholder</span>
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HeroSection;
